export class MicrosoftProcessAdminConsentRequest{
    public adminConsent!:boolean;
    public code?:string;
    public state!: string;
    public nonce!: string;
}
